module.exports = __webpack_public_path__ + "static/media/background-3.e1abfb96.jpg";